import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import { AccountCircle, Upload, Dashboard, Settings as SettingsIcon, CalendarMonth, Email, Business, AdminPanelSettings, VideoCall, Analytics } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import TrialIndicator from '../common/TrialIndicator';
import logo from '../common/EchoNoteLogo.svg';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <img 
              src={logo} 
              alt="EchoNote Logo" 
              style={{ width: '40px', height: '40px', marginRight: '12px' }} 
            />
            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
              EchoNote
            </Typography>
          </Box>
          
          <Box sx={{ flexGrow: 1 }} />
          
          <Button 
            color="inherit" 
            startIcon={<Dashboard />}
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 1 }}
          >
            Dashboard
          </Button>
          
          <Button 
            color="inherit" 
            startIcon={<VideoCall />}
            onClick={() => navigate('/host-dashboard')}
            sx={{ mr: 1 }}
          >
            Meetings
          </Button>

          <Button 
            color="inherit" 
            startIcon={<Analytics />}
            onClick={() => navigate('/analytics')}
            sx={{ mr: 1 }}
          >
            Analytics
          </Button>
          
          <Button 
            color="inherit" 
            startIcon={<Upload />}
            onClick={() => navigate('/upload')}
            sx={{ mr: 1 }}
          >
            Upload
          </Button>

          <Button 
            color="inherit" 
            startIcon={<CalendarMonth />}
            onClick={() => navigate('/scheduler')}
            sx={{ mr: 1 }}
          >
            Scheduler
          </Button>

          <Button 
            color="inherit" 
            startIcon={<Email />}
            onClick={() => navigate('/email-debug')}
            sx={{ mr: 1 }}
          >
            Emails
          </Button>

          {user?.organization && (user?.orgRole === 'org_admin') && (
            <Button 
              color="inherit" 
              startIcon={<Business />}
              onClick={() => navigate('/organization')}
              sx={{ mr: 1 }}
            >
              Organization
            </Button>
          )}

          {user?.role === 'admin' && (
            <Button 
              color="inherit" 
              startIcon={<AdminPanelSettings />}
              onClick={() => navigate('/admin')}
              sx={{ mr: 2 }}
            >
              Admin
            </Button>
          )}

          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem disabled>
                <Box>
                  <Typography variant="body2" color="textSecondary">
                    {user?.firstName} {user?.lastName}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {user?.organization?.name || 'No organization'}
                  </Typography>
                </Box>
              </MenuItem>
              <MenuItem onClick={() => { handleClose(); navigate('/settings'); }}>
                <SettingsIcon sx={{ mr: 1 }} fontSize="small" />
                Settings
              </MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
        <TrialIndicator />
        {children}
      </Container>
    </Box>
  );
};

export default Layout;